import styles from './ra-skeleton-loader.module.scss'

export interface RaSkeletonLoaderProps {
  width?: string
  height?: string
  borderRadius?: number
  margin?: string
}

export const RaSkeletonLoader = ({
  width = '100%',
  height = 'auto',
  borderRadius = 5,
  margin = '6px 0px',
}) => {
  return (
    <div
      className={styles['ra-skeleton-loader']}
      style={{
        width,
        height,
        borderRadius,
        margin,
      }}></div>
  )
}
